import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
 
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    //1. Get the token from the URL
    let token = route.queryParams['token'];
    if (token) {
      //Save it to local storage
      localStorage.setItem('f2-token', token);

      //Proceed to the route
      return true;
    }

    //2. If there is no token in the url, try to get it from local storage
    token = localStorage.getItem('f2-token');
    if (token) return true;

    //3. If there is no token in the url or local storage, redirect to error page
    this.router.navigate(['/scans/sample-scan1']);
    return false;
  }
}
